import { Service } from '../service';
import { mergeDeep } from '../../util/helpers';
import presets from './presets';
export class Icons extends Service {
    constructor(preset) {
        super();
        const { iconfont, values, component } = preset[Icons.property];
        this.component = component;
        this.iconfont = iconfont;
        this.values = mergeDeep(presets[iconfont], values);
    }
}
Icons.property = 'icons';
